import React, { useState } from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiSearch, FiDollarSign } = FiIcons;

export default function Step1Lookup({ onSubmit }) {
  const [carrier, setCarrier] = useState('Verizon');
  const [amount, setAmount] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (amount) onSubmit({ carrier, amount });
  };

  return (
    <motion.div 
      initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}
      className="card-premium"
    >
      <div className="text-center mb-8">
        <h2 className="text-3xl font-bold text-slate-900 mb-2">Carrier Lookup</h2>
        <p className="text-slate-600">Let's find out exactly what it takes to break free.</p>
      </div>

      <form onSubmit={handleSubmit} className="space-y-6">
        <div>
          <label className="block text-sm font-medium text-slate-700 mb-2">Current Carrier</label>
          <select 
            value={carrier} onChange={(e) => setCarrier(e.target.value)}
            className="block w-full rounded-lg border-slate-300 border py-3 px-4 text-slate-900 focus:ring-blue-500 focus:border-blue-500 outline-none"
          >
            <option>Verizon</option>
            <option>AT&T</option>
            <option>T-Mobile</option>
            <option>Other</option>
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-slate-700 mb-2">Estimated Payoff Amount</label>
          <div className="relative rounded-md shadow-sm">
            <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
              <SafeIcon icon={FiDollarSign} className="h-5 w-5 text-slate-400" />
            </div>
            <input
              type="number" required min="1"
              className="block w-full pl-11 pr-4 py-3 border-slate-300 border rounded-lg focus:ring-blue-500 focus:border-blue-500 outline-none text-lg"
              placeholder="0.00"
              value={amount} onChange={(e) => setAmount(e.target.value)}
            />
          </div>
        </div>

        <button type="submit" className="w-full btn-primary py-4 text-lg mt-4">
          <SafeIcon icon={FiSearch} className="mr-2" />
          Check Eligibility
        </button>
      </form>
    </motion.div>
  );
}